import React, { FocusEventHandler } from "react";
import Select from "react-select";

export interface OptionSelect {
  [x: string]: any;
  readonly label: string;
  readonly value?: string;
  readonly options?: OptionSelect[];
  readonly isDisabled?: boolean;
}

interface SelectComponentProps {
  //* Propesties
  defaultValue?: OptionSelect;
  options: OptionSelect[];
  isMulti?: boolean;
  label: string;
  placeholder?: string;
  id: string;
  isError?: boolean;
  errorMessage?: string;
  value?: OptionSelect;
  isDisabled?: boolean;

  // * Methods
  onChange: (e: OptionSelect) => void;
  onBlur?: FocusEventHandler<HTMLInputElement>;
}

export const SelectComponent: React.FC<SelectComponentProps> = ({
  defaultValue,
  options,
  isMulti,
  label,
  placeholder,
  id,
  isError,
  errorMessage,
  value,
  isDisabled = false,
  onChange,
  onBlur,
}) => {
  return (
    <div className="mb-3 container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
      <label className="inline-block mb-2 text-base font-medium">{label}</label>
      <Select
        className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
        id={id}
        data-choices
        name="choices-multiple-default"
        placeholder={placeholder}
        defaultValue={[defaultValue]}
        isMulti={isMulti}
        options={options}
        onChange={(e) => onChange(e as OptionSelect)}
        onBlur={onBlur}
        value={value ?? ""}
        isDisabled={isDisabled}
      />
      {isError ? (
        <p className="mt-1 text-sm text-red-500">{errorMessage}</p>
      ) : null}
    </div>
  );
};
